import type { TextSizingConfigs } from './utils';
import { devices } from '../common/devices';
import { colors, darkThemeSelector, styled } from '../stitches.config';
import { Text } from './Text';

const largeVars = {
  touch: {
    size: 18,
    lineHeight: 28,
  },
  mouse: {
    size: 16,
    lineHeight: 24,
  },
} as const satisfies TextSizingConfigs;

const LargeBase = {
  color: colors.bodyNeutralLight,
  [darkThemeSelector]: {
    color: colors.bodyNeutralDark,
  },
  variants: {
    internal: {
      true: {
        color: colors.internalBodyLight,
        [darkThemeSelector]: {
          color: colors.internalBodyDark,
        },
      },
      false: {},
    },
  },
};

export const LargeSansSizes = {
  '&': {
    [devices.touch]: {
      fontSize: `$${largeVars.touch.size}`,
      lineHeight: `$${largeVars.touch.lineHeight}`,
    },

    [devices.mouse]: {
      fontSize: `$${largeVars.mouse.size}`,
      lineHeight: `$${largeVars.mouse.lineHeight}`,
    },
  },
};

export const LargeMonoSizes = {
  '&': {
    [devices.touch]: {
      fontSize: `$${largeVars.touch.size - 1}`,
      lineHeight: `$${largeVars.touch.lineHeight}`,
    },

    [devices.mouse]: {
      fontSize: `$${largeVars.mouse.size - 1}`,
      lineHeight: `$${largeVars.mouse.lineHeight}`,
    },
  },
};

export const Large = styled(Text, LargeBase, {
  variants: {
    family: {
      regular: LargeSansSizes,
      monospace: LargeMonoSizes,
    },
  },
  defaultVariants: {
    family: 'regular',
  },
});
Large.displayName = 'Large';
